import React, { useCallback } from 'react';

import { DataDisplayTable, WithSubData } from 'ui-kit/Table/DataDisplayTable';

import { ComparisonData } from './comparisonTable.config';
import { getDefaultColumns } from './comparisonTable.utils';

interface ComparisonTableProps {
  data: ComparisonData[];
  bidPX: {
    min: number;
    max: number;
  };
}
const ComparisonTable = ({ data, bidPX }: ComparisonTableProps) => {
  const tableData: WithSubData<ComparisonData>[] = data.map((deal) => {
    return {
      ...(deal as ComparisonData),
      last_updated_date: '',
      subData: [],
    } satisfies WithSubData<ComparisonData>;
  });

  const generateRowId = (dealId: string | null, listingId: string) => `${dealId}:${listingId}`;

  const getRowId = useCallback((row: any) => {
    const typedRow = row as WithSubData<ComparisonData>;
    return generateRowId(typedRow?.deal?.id, typedRow?.bid_id);
  }, []);

  const columnsToUse = getDefaultColumns(bidPX).filter(Boolean) as any;

  return (
    <DataDisplayTable
      getRowId={getRowId}
      canResize={false}
      data={tableData}
      columns={columnsToUse}
      noDataMessage={'No Data Found'}
      isSelectionInfoIcon={false}
      thClasses="bg-slate-950"
      tableClasses="border-separate [border-spacing:0_8px] bg-slate-950"
      stylingOptions={{
        rowColor: 'bg-gray-950',
        alternateLightRows: false,
        hoverRowColor: 'brand_dark',
        selectedRowColor: 'bg-gray-1000',
      }}
      pillBtnVariant={'muted_light'}
      downloadCSV={false}
      isDraggable={false}
    />
  );
};

export default ComparisonTable;
